<template>
    <v-layout wrap class="pa-3" v-if="user.organisation.organisation_type !== null">
        <v-flex xs12 class="pa-0" v-for="(field, index) in fields()" :key="index">
            <fields-d-text-field    @input="change()"             v-if="field.type == 'text'"     :label="field.name" v-model="user.organisation.details[field.field]"></fields-d-text-field>                       
            <fields-d-email-field   @input="change()"             v-if="field.type == 'email'"    :label="field.name" v-model="user.organisation.details[field.field]"></fields-d-email-field>    
            <fields-d-phone-field   @input="change()"             v-if="field.type == 'phone'"                        v-model="user.organisation.details[field.field]"></fields-d-phone-field>    
            <fields-o-address-field @blur="change()"              v-if="field.type == 'address'"                                                           ></fields-o-address-field>
            <!-- <fields-d-address-field @blur="change" estate       v-if="field.type == 'estate'"                                                            ></fields-d-address-field> -->
            <fields-d-date-object-field @blur="change()"          v-if="field.type == 'date'"     :label="field.name" v-model="user.organisation[field.field]"></fields-d-date-object-field>                       
            <fields-d-switch        @input="change()"             v-if="field.type == 'switch'"   :label="field.name" v-model="user.organisation[field.field]"></fields-d-switch>
            <fields-d-checkbox      @input="change()"             v-if="field.type == 'checkbox'" :label="field.name" v-model="user.organisation[field.field]"></fields-d-checkbox>
            <fields-d-yes-no        @input="change()"             v-if="field.type == 'yes-no'"   :label="field.name" v-model="user.organisation[field.field]"></fields-d-yes-no>
            <fields-d-text-area     @input="change()"             v-if="field.type == 'textarea'" :label="field.name" v-model="user.organisation[field.field]"></fields-d-text-area>                       
        </v-flex>                                     
    </v-layout>
</template>

<script>
import { mapState } from "vuex";
// import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState(["user", "organisations"])
  },
  methods: {
    change() {
      this.$store.commit("app/setChange");
    },
    fields() {
      var res = this.organisations.types.filter(type => {
        return type.reference == this.user.organisation.organisation_type;
      });
      return res[0].fields;
    }
  }
};
</script>
